import React from 'react';
import { Box } from '@mui/material';
import CIHAChartsContainer from '../Common/CIHAChartsContainer';
import EpidemiologyWrapper from './index';

const Epidemiology = () => {
    return (
        <Box>
            <Box className="content">
                <CIHAChartsContainer
                    title={'Epidemiologia / Diagnósticos'}
                    className="services-container-dashboards"
                >
                    <EpidemiologyWrapper />
                </CIHAChartsContainer>
            </Box>
        </Box>
    );
};

export default Epidemiology;